import { render, staticRenderFns } from "./AppealLayout.vue?vue&type=template&id=328762e4&scoped=true"
import script from "./AppealLayout.vue?vue&type=script&lang=js"
export * from "./AppealLayout.vue?vue&type=script&lang=js"
import style0 from "./AppealLayout.vue?vue&type=style&index=0&id=328762e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328762e4",
  null
  
)

export default component.exports